import React, { useEffect } from 'react'
import MainLayout from '../../components/MainLayout/MainLayout'
import { Button, Card, Col, Row } from 'antd'
import ClientsTable from './components/ClientsTable/ClientsTable'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchCompaniesRequest } from '../../redux/reducers/clients/clientsSlice'

const Clients = () => {
    const { t } = useTranslation('clients');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCompaniesRequest())
    }, [])

    return (
        <MainLayout>
            <Row style={{ paddingBottom: 24 }}>
                <Col xs={24}>
                    <Card
                        bodyStyle={{ padding: "0px" }}
                        extra={
                            <Button onClick={() => navigate('/clients/add-clients')} size={"middle"} className='card-button-title'>
                                {t('add_new_client')}
                            </Button>
                        }
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('clients')}</span>}
                    >
                        <ClientsTable />
                    </Card>
                </Col>
            </Row>
        </MainLayout>
    )
}

export default Clients
